export default __webpack_public_path__ + "static/media/Group 1651.d40d8752.png";